import {AnalyticsEventDataI, AnalyticsEventTypeI, AnalyticsProviderInterface} from '../analytics.provider.i';

import * as mixpanel from 'mixpanel-browser';

export class MixpanelAnalyticsProvider implements AnalyticsProviderInterface {

    private mixpanel: any = mixpanel;

    constructor(token: string) {
        this.mixpanel.init(token);
        console.log('Mixpanel analytics is enabled!');
    }

    trackEvent<T extends keyof AnalyticsEventTypeI>(event_type: T, event_data: any, cb?: () => void) {
        switch (event_type) {
            case 'event':
                let _event_data: AnalyticsEventDataI = event_data;
                this.mixpanel.track(_event_data.category, _event_data);
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/analytics/providers/mixpanel.analytics.provider.ts